import { render, staticRenderFns } from "./DrawerDialogControls.vue?vue&type=template&id=5a679a6c&scoped=true&"
import script from "./DrawerDialogControls.vue?vue&type=script&lang=js&"
export * from "./DrawerDialogControls.vue?vue&type=script&lang=js&"
import style0 from "./DrawerDialogControls.vue?vue&type=style&index=0&id=5a679a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a679a6c",
  null
  
)

export default component.exports